import useMutationApi from 'src/api/useMutationApi';

interface RefreshEdiTransactionResponse {
  success: boolean;
  message: string;
}

const useRefreshEdiTransaction = ({
  salesOrderDraftId,
  onSuccess,
  onError,
}: {
  salesOrderDraftId: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  return useMutationApi<void, RefreshEdiTransactionResponse>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/refresh-edi-transaction`,
    method: 'POST',
    successMessage: 'EDI transaction refreshed successfully',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useRefreshEdiTransaction;
